import type { ReaderPdfBookManifest } from "@/interface/DTO_Interfaces"
import { bundledPdfBookToc } from "@/ts/pdf-outline"

const bundledContentVersion = "2026-09-07"
const moscowContentVersion = "2026-09-28"

export const bundledPdfBookManifest: ReaderPdfBookManifest = {
        id: "informatika",
        title: "Прикладная информатика. 10 класс",
        chapterTitle: "Главы 1–2. Программирование и алгоритмы обработки данных",
        description: "Прикладная информатика. 10 класс",
        language: "ru",
        overviewPath: "/10kl/informatika",
        readPath: "/10kl/informatika/read/page",
        firstPageNumber: 5,
        coverSrc: `${import.meta.env.BASE_URL}content/informatic/informatika-10kl.jpg`,
        coverAlt: "Обложка «Прикладная информатика. 10 класс»",
        windowsInstallerSrc: `${import.meta.env.BASE_URL}downloads/windows/informatika-10kl-x64-setup.exe`,
        macosDmgSrc: `${import.meta.env.BASE_URL}downloads/macos/informatic-10kl-aarch64.dmg`,
        androidApkSrc: `${import.meta.env.BASE_URL}downloads/android/informatic-10kl.apk`,
        linuxAppImageSrc: `${import.meta.env.BASE_URL}downloads/linux/informatic-10kl-x64.AppImage`,
        fallbackToc: bundledPdfBookToc,
        pdf: {
                id: "informatic",
                src: `${import.meta.env.BASE_URL}content/informatic/informatic.pdf?v=${bundledContentVersion}`,
                pageMapSrc: `${import.meta.env.BASE_URL}content/informatic/page-map.json?v=${bundledContentVersion}`,
                overviewSrc: `${import.meta.env.BASE_URL}content/informatic/book-overview.json?v=${bundledContentVersion}`,
                layout: "spread",
        },
}

export const moscowHistoryBookManifest: ReaderPdfBookManifest = {
        id: "istoriya-nashego-kraya-moskva",
        title: "История Москвы. 5 класс",
        chapterTitle: "С древности до середины XVI века",
        description: "История Москвы. 5 класс",
        language: "ru",
        overviewPath: "/5kl/istoriya-nashego-kraya-moskva",
        readPath: "/5kl/istoriya-nashego-kraya-moskva/read/page",
        firstPageNumber: 1,
        overviewPageCount: 240,
        coverSrc: `${import.meta.env.BASE_URL}content/istoriya-nashego-kraya-moskva/moskva-5kl.jpg`,
        coverAlt: "Обложка «История Москвы. 5 класс»",
        windowsInstallerSrc: `${import.meta.env.BASE_URL}downloads/windows/moscow-5kl-x64-setup.exe`,
        androidApkSrc: `${import.meta.env.BASE_URL}downloads/android/moscow-5kl.apk`,
        linuxAppImageSrc: `${import.meta.env.BASE_URL}downloads/linux/moscow-5kl-x64.AppImage`,
        pdf: {
                id: "moscow-history-5-2026",
                src: `${import.meta.env.BASE_URL}content/istoriya-nashego-kraya-moskva/textbook.pdf?v=${moscowContentVersion}`,
                pageMapSrc: `${import.meta.env.BASE_URL}content/istoriya-nashego-kraya-moskva/page-map.json?v=${moscowContentVersion}`,
                overviewSrc: `${import.meta.env.BASE_URL}content/istoriya-nashego-kraya-moskva/book-overview.json?v=${moscowContentVersion}`,
                tocSrc: `${import.meta.env.BASE_URL}content/istoriya-nashego-kraya-moskva/toc.json?v=${moscowContentVersion}`,
                layout: "facing",
        },
}

export const readerPdfBookManifests = import.meta.env.VITE_EBOOK_TARGET === "informatic10"
        ? [bundledPdfBookManifest]
        : import.meta.env.VITE_EBOOK_TARGET === "moscow5"
                ? [moscowHistoryBookManifest]
                : [bundledPdfBookManifest, moscowHistoryBookManifest]

export const defaultReaderPdfBookManifest = readerPdfBookManifests[0]

export const getReaderPdfBookManifest = (bookId: unknown) =>
        readerPdfBookManifests.find((book) => book.id === bookId) ?? null
